module.exports = __webpack_public_path__ + "static/img/03.4f11ced9.png";